module.exports = __webpack_public_path__ + "static/media/ds02.24f85fc4.jpg";